export default {
  "fontElementMap": "BNlVa",
  "orderedlist": "S-9-b",
  "bulletedlist": "qMiL2",
  "listItem": "RiQ-A"
};